import React from 'react';

class ChefLocationList extends React.Component {
  render() {
    const { className = 'chef-location' } = this.props;
    return (
      <div className={className}>
        {this.props.availableServiceDistricts
          .sort(dist => dist.sort_order)
          .map(dist => this.renderDistrict(dist))}
      </div>
    );
  }

  renderDistrict(district) {
    const { showSubDistricts } = this.props;

    if (district && district.service_district_subsections.length > 0) {
      const { toggleGroup = () => {} } = this.props;
      const classNames = ['chef-location__group'];
      if (this.isGroupSelected(district))
        classNames.push('chef-location__group--active');

      if (showSubDistricts) {
        return (
          <div key={district.name} className="chef-location__district">
            {this.renderDistrictAndSubdistrictSelections(
              district,
              classNames,
              toggleGroup
            )}
          </div>
        );
      } else {
        return (
          <div key={district.name} className="chef-location__district">
            <div
              className={classNames.join(' ')}
              onClick={() => toggleGroup(district)}
            >
              <p className="p">{district.name}</p>
            </div>
          </div>
        );
      }
    }
  }

  renderDistrictAndSubdistrictSelections = (
    district,
    classNames,
    toggleGroup
  ) => {
    return (
      <React.Fragment>
        <h3 className="h3">{district.name}</h3>
        <div
          className={classNames.join(' ')}
          onClick={() => toggleGroup(district)}
        >
          <p className="p">Select all {district.name} locations.</p>
        </div>
        <div className="chef-location__list">
          {district.service_district_subsections.map(subdistict =>
            this.renderSubdistrict(subdistict)
          )}
        </div>
      </React.Fragment>
    );
  };

  renderSubdistrict(subdistrict) {
    const {
      serviceDistricts = [],
      toggleDistrict = () => {},
      itemClass = 'chef-location__sub-district'
    } = this.props;
    const classes = [itemClass];
    const {
      name = '',
      neighborhoods = [] /*, transportation_options=[]*/
    } = subdistrict;

    const isActive = serviceDistricts.findIndex(sd => sd.id === subdistrict.id);

    if (isActive >= 0) {
      classes.push('chef-location__sub-district--active');
    }

    return (
      <div
        key={name}
        className={classes.join(' ')}
        onClick={() => toggleDistrict(subdistrict)}
      >
        <p className="p p--bold">{name}</p>
        <p className="p">{neighborhoods.join(', ')}</p>
      </div>
    );
  }

  isGroupSelected = group => {
    const { serviceDistricts = [] } = this.props;
    const groupIds = group.service_district_subsections.map(d => d.id);
    const selectedIds = serviceDistricts.map(d => d.id);

    return groupIds.every(id => selectedIds.includes(id));
  };
}

export default ChefLocationList;



// WEBPACK FOOTER //
// ./src/components/chef/ChefLocationList.js